import React, { useEffect, useState } from "react";
import { useAuth } from "../Authentication/AuthContext";
import PublicHeader from "./PublicHeader";
import UserHeader from "./UserHeader";
import VendorHeader from "./VendorHeader";
import { useGetVendorKYCStatusQuery } from "../../redux/service/vendorService";
import { setVendorIsApproved } from "../../redux/slice/upSwapSlice";
import { useDispatch, useSelector } from "react-redux";

const Header = () => {
  const { userRole, userData, loading, setUserRole } = useAuth();
    const dispatch = useDispatch();
  
  const [userType, setUserType] = useState(
    localStorage.getItem("userRole") || ""
  );

  const vendorId = localStorage.getItem("vendor_id");

  const {
    data: kycData,
    isLoading: kycDataIsLoading,
    isFetching: kycDataIsFetching,
  } = useGetVendorKYCStatusQuery(vendorId, { skip: !vendorId });

  useEffect(() => {
    if (!kycDataIsFetching && !kycDataIsLoading) {
      dispatch(setVendorIsApproved(kycData?.is_approved));
    }
  }, [kycDataIsLoading, kycDataIsFetching, kycData]);

    const { vendorIsApproved } = useSelector((state) => state.upSwap);

  useEffect(() => {
    if (!vendorIsApproved && userType === "user") {
      setUserRole("user");
    }else if (vendorIsApproved){
      setUserRole("vendor");
    }
  }, [userType, userData?.vendor_id]);

  if (loading) {
    return (
      <header className="bg-white shadow-sm py-4 px-6 text-center text-gray-600">
        Loading Header...
      </header>
    );
  }
  if (userRole === "user") {
    return <UserHeader userData={userData} />;
  } else if (userRole === "vendor") {
    return <VendorHeader userData={userData} />;
  } else {
    // userRole === 'public'
    return <PublicHeader />;
  }
};

export default Header;
